function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-console */
import { Tokens } from '../../themes/default/spacing';
import { spacingValues } from './constants';
export var themeSpacing = function themeSpacing() {
  var spacingOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedSpacing = _objectSpread({}, spacingValues);

  var shapeTokens = Object.keys(Tokens);
  Object.keys(spacingOverrides).forEach(function (spacingName) {
    if (shapeTokens.indexOf(spacingName) === -1) {
      if (typeof spacingOverrides[spacingName] === 'number') {
        themedSpacing[spacingName] = spacingOverrides[spacingName];
      } else {
        console.error("Spacing override must be a number - ignoring ".concat(spacingName, " override"));
      }
    } else {
      console.error("User may not override Spacing Tokens: ".concat(Object.keys(Tokens), " - ignoring ").concat(spacingName, " override"));
    }
  });
  return themedSpacing;
};